import  {apis,request,methods} from "../request";
export const httpLanguage = ()=>{
    return request(methods.get,apis.getLanguage)
 }

 